import { LayoutBlock } from '@/layout';
import { RouteConfig } from 'vue-router';

const organizationRouting: RouteConfig[] = [
    {
        path: 'organization',
        meta: { title: '组织结构' },
        component: LayoutBlock,
        redirect: '/app/organization/login-user',
        children: [
            // 账号
            {
                name: 'login-user',
                path: 'login-user',
                component: () => import(/* webpackChunkName: "admin" */ './login-user/login-user.vue'),
                meta: { title: '账号' },
            },
        ],
    },
];

export default organizationRouting;
